export default __webpack_public_path__ + "static/media/prev-M-Receiver-5.dc1d946a.png";